import React from 'react'
import PropTypes from 'prop-types'
import TooltipTheme from '@mui/material/Tooltip'
import { withStyles } from '~/themes/useStyles'
import { COLORS } from '~/themes/common'

const style = () => ({
  icon: {
    cursor: 'pointer',
    display: 'inline-flex',

    '& img': {
      maxWidth: '100%',
    },
  },
})

const TooltipStyled = withStyles(() => ({
  tooltip: {
    background: COLORS.gray.textGray3,
    color: COLORS.palette.white,
    fontSize: 14,
    fontWeight: 300,
    padding: 16,
    borderRadius: 8,
  },
}))(TooltipTheme)

const Tooltip = ({
  classes,
  icon,
  content,
  placement,
  tooltipClasses,
  size,
  ...props
}) => (
  <TooltipStyled
    title={content}
    placement={placement}
    classes={{ ...tooltipClasses }}
    enterTouchDelay={5}
    {...props}
  >
    <div className={classes.icon} style={{ width: size || 'auto' }}>
      {icon || <img src="/icons/info.svg" alt="info" />}
    </div>
  </TooltipStyled>
)
Tooltip.defaultProps = {
  placement: 'bottom',
  icon: null,
  tooltipClasses: {},
  size: 0,
}

Tooltip.propTypes = {
  classes: PropTypes.shape().isRequired,
  icon: PropTypes.node,
  content: PropTypes.node.isRequired,
  placement: PropTypes.string,
  tooltipClasses: PropTypes.shape(),
  size: PropTypes.number,
}

export default withStyles(style)(Tooltip)
